import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
const sizeClasses = {
  base: {
    cell: "h-6 min-w-6",
    text: "text-sm md:text-base"
  },
  sm: {
    cell: "h-5 min-w-5",
    text: "text-sm"
  }
} as const;
interface DigitBadgeProps extends Omit<React.ComponentProps<"span">, "children"> {
  size?: keyof typeof sizeClasses;
  value: number;
}
export function DigitBadge(t0) {
  const $ = _c(26);
  let className;
  let props;
  let t1;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      size: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = value;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    value = $[4];
  }
  const size = t1 === undefined ? "base" : t1;
  let t2;
  if ($[5] !== value) {
    t2 = new Intl.NumberFormat("en-US").format(value);
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const formatted = t2;
  let t3;
  if ($[7] !== value) {
    t3 = Array.from(String(value));
    $[7] = value;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const digits = t3;
  let t4;
  if ($[9] !== className) {
    t4 = cn("mb-px inline-flex select-none items-center justify-center rounded-lg bg-gray-background p-0.75 align-middle shadow-custom", className);
    $[9] = className;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== formatted) {
    t5 = <span className="sr-only">{formatted}</span>;
    $[11] = formatted;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = sizeClasses[size];
  let t7;
  if ($[13] !== t6.text) {
    t7 = cn("inline-flex divide-x divide-gray-400 rounded-[5px] bg-preview-bg text-text-paragraph tabular-nums shadow-custom", t6.text);
    $[13] = t6.text;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== digits || $[16] !== size) {
    t8 = digits.map((digit, index) => <span className={cn("flex items-center justify-center px-1 leading-none", sizeClasses[size].cell)} key={`digit-${index}`}>{digit}</span>);
    $[15] = digits;
    $[16] = size;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <span aria-hidden={true} className={t7}>{t8}</span>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== props || $[22] !== t4 || $[23] !== t5 || $[24] !== t9) {
    t10 = <span className={t4} {...props}>{t5}{t9}</span>;
    $[21] = props;
    $[22] = t4;
    $[23] = t5;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}